(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-score/assets/javascripts/event-participant-outcome.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-score/assets/javascripts/event-participant-outcome.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo,
  useState = _React.useState;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useCouponContext = svs.components.tipsen.couponComponents.useCouponContext;
const makeSelectEventOutcomesFromBitmap = svs.components.tipsen.engine.selectors.couponSelectors.makeSelectEventOutcomesFromBitmap;
const Coupon = svs.components.tipsen.couponComponents.Coupon;
const _svs$components$tipse = svs.components.tipsen.hooks,
  useIsTipsinfoEnabled = _svs$components$tipse.useIsTipsinfoEnabled,
  getOutcomeLabels = _svs$components$tipse.getOutcomeLabels;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const selectEngineOutcomes = svs.components.tipsen.engine.selectors.engineSelectors.selectEngineOutcomes;
const ReactButton = svs.ui.ReactButton;
const MATCHEN = svs.utils.products.productIds.MATCHEN;
const getOutcomeAriaLabelScore = svs.components.poolBetting.ariaUtils.getOutcomeAriaLabelScore;
const formatDistributionValue = value => value ? "".concat(value, "%") : '0%';
const EventParticipantOutcome = _ref => {
  let distributions = _ref.distributions,
    eventNumber = _ref.eventNumber,
    outcomeGroupIndex = _ref.outcomeGroupIndex,
    productId = _ref.productId,
    sportType = _ref.sportType,
    teamName = _ref.teamName;
  const _useCouponContext = useCouponContext(),
    couponId = _useCouponContext.couponId;
  const selectOutcomes = useMemo(makeSelectEventOutcomesFromBitmap, []);
  const boardIndex = 0;
  const selections = useSelector(state => selectOutcomes(state, couponId, boardIndex, eventNumber, outcomeGroupIndex));
  const _useIsTipsinfoEnabled = useIsTipsinfoEnabled(),
    isSvenskaFolketAsOutcomesEnabled = _useIsTipsinfoEnabled.isSvenskaFolketAsOutcomesEnabled;
  const shouldPairDistributionWithOutcomes = !isSvenskaFolketAsOutcomesEnabled;
  const outcomeCount = useSelector(selectEngineOutcomes).outcomeCount;
  const outcomeHeatmap = useSelector(selectEngineOutcomes).outcomeHeatmap[sportType];
  const hasMoreOutcomes = outcomeHeatmap.minValue !== outcomeHeatmap.minStartValue || outcomeHeatmap.maxValue !== outcomeHeatmap.maxStartValue;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAllOutcomes = _useState2[0],
    setShowAllOutcomes = _useState2[1];
  const minValue = showAllOutcomes ? outcomeHeatmap.minValue : outcomeHeatmap.minStartValue;
  const maxValue = showAllOutcomes ? outcomeHeatmap.maxValue : outcomeHeatmap.maxStartValue;
  const outcomeLabels = getOutcomeLabels(minValue, maxValue, productId, teamName);
  const outcomes = useMemo(() => {
    const outcomesArray = outcomeLabels.map(outcome => ({
      ariaLabel: getOutcomeAriaLabelScore({
        svenskaFolketValue: isSvenskaFolketAsOutcomesEnabled ? formatDistributionValue(distributions === null || distributions === void 0 ? void 0 : distributions[outcome.sign]) : undefined,
        sign: outcome.sign,
        participantName: teamName
      }),
      sign: isSvenskaFolketAsOutcomesEnabled ? formatDistributionValue(distributions === null || distributions === void 0 ? void 0 : distributions[outcome.sign]) : outcome.text,
      isSelected: Boolean(selections[outcome.sign]),
      outcomeValue: outcome.sign
    }));
    return [...outcomesArray];
  }, [distributions, isSvenskaFolketAsOutcomesEnabled, outcomeLabels, selections, teamName]);
  return React.createElement(React.Fragment, null, React.createElement(Coupon.BetButtons, {
    boardIndex: boardIndex,
    className: "pg_coupon_row__event__participant__outcome__bet_buttons_grid",
    distributions: shouldPairDistributionWithOutcomes ? distributions : [],
    eventNumber: eventNumber,
    isClickable: true,
    outcomeCount: outcomeCount,
    outcomeGroupIndex: outcomeGroupIndex,
    outcomes: outcomes
  }), hasMoreOutcomes && React.createElement(ReactButton, {
    "aria-expanded": showAllOutcomes,
    "aria-label": showAllOutcomes ? 'Visa färre' : 'Visa fler',
    className: "pg_coupon_row__show_more_btn",
    onClick: () => setShowAllOutcomes(!showAllOutcomes)
  }, showAllOutcomes ? 'Visa färre' : 'Visa fler'));
};
setGlobal('svs.components.tipsen.couponScore.EventParticipantOutcome', EventParticipantOutcome);

 })(window);